<template>
  <article class="section__content mobile-content__item">
    <Image v-if="image" class="mobile-content__image" :source="image" />

    <h4 v-if="legend" class="mobile-content__legend">{{ legend }}</h4>
    <h3 class="section__title">{{ name || title }}</h3>
    <RawHtml :html="text" class="mobile-content__text" />

    <div v-if="links.length" class="mobile-content__text">
      <h5 v-if="linksHeading" class="mobile-content__heading">
        {{ linksHeading }}
      </h5>

      <a
        v-for="{ href, label } in links"
        :key="label"
        :href="href"
        target="_blank"
        rel="noopener"
        class="button -border -alt -link -full-width mobile-content__link"
        >{{ label }}
      </a>
    </div>
  </article>
</template>

<script>
import Image from '@/components/global/Image.vue'
import RawHtml from '@/components/global/RawHtml.vue'

export default {
  name: 'MobileContent',
  components: { Image, RawHtml },
  props: {
    legend: { type: [String, Boolean], default: null },
    image: { type: Object, default: null },
    name: { type: String, default: null },
    title: { type: String, default: null },
    text: { type: String, default: null },
    links: { type: Array, default: [] },
    linksHeading: { type: String, default: null },
  },
}
</script>
